import React, { useContext } from 'react';
import { Link } from 'react-router-dom'
import AuthContext from '../context/AuthContext';
import rolesPermissions from '../context/Roles';
import { Row, Col } from 'react-bootstrap';
//Styles
import '../appstyles/Home.css'
import IconsHome from '../assets/imagenes/icons_home.png'

const hasAnyPermission = (role, feature, actions) => {
  return actions.some(action => rolesPermissions[role]?.[feature]?.[action]);
};

function Home() {
  const { auth } = useContext(AuthContext);

  //conditional rendering of items
  const canAccessClients = auth?.role && hasAnyPermission(auth?.role, 'cliente', ['read']);
  const canAccessProducts = auth?.role && hasAnyPermission(auth?.role, 'producto', ['read']);
  const canAccessSuppliers = auth?.role && hasAnyPermission(auth?.role, 'proveedor', ['read']);

  return (
    <main className='home'>
      <section className='HomeContent' >
        <h3>Bienvenido al portal de gestión</h3>
        <p>En el menú lateral encontrarás las secciones y funciones disponibles para ti</p>
        <hr />
        <h3>Acciones Rápidas</h3>
        {canAccessClients || canAccessProducts || canAccessSuppliers ? (
            <>
        <section className="QuickActions">
          <div className="quick-actions">
            {canAccessClients &&
            <Link to="/clientslist">
              <div className="quick-action">
                <h4>Clientes</h4>
              </div>
            </Link>
            }

            {canAccessProducts &&
            <Link to="/productslist">
              <div className="quick-action">
                <h4>Productos</h4>
              </div>
            </Link>
            }

            {canAccessSuppliers &&
            <Link to="/supplierslist">
              <div className="quick-action">
                <h4>Proveedores</h4>
              </div>
            </Link>
            }
          </div>
          <div className='iconsHome'>
            <img src={IconsHome} alt="iconsHome"/>
          </div>
        </section>
        </>
        ) : (
        <Row>
          <Col>
            <p style={{paddingLeft: '10px'}}>No cuentas con acciones rápidas disponibles.</p>
          </Col>

          <Col>
            <div className='iconsHome'>
              <img src={IconsHome} alt="iconsHome"/>
            </div>
          </Col>
        </Row>
        )}

      </section>
    </main>
  )
}

export default Home